var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 7.5835H9.33341M4.66675 7.5835H4.67199M7.58341 9.91683H4.66675M9.33341 9.91683H9.32816",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.1665V2.33317M3.5 1.1665V2.33317",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45825 7.14187C1.45825 4.60013 1.45825 3.32925 2.18866 2.53962C2.91906 1.75 4.09462 1.75 6.44575 1.75H7.55408C9.90521 1.75 11.0808 1.75 11.8112 2.53962C12.5416 3.32925 12.5416 4.60013 12.5416 7.14187V7.44147C12.5416 9.98322 12.5416 11.2541 11.8112 12.0437C11.0808 12.8333 9.90521 12.8333 7.55408 12.8333H6.44575C4.09462 12.8333 2.91906 12.8333 2.18866 12.0437C1.45825 11.2541 1.45825 9.98322 1.45825 7.44147V7.14187Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.6665H12.25",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.50c6ece173a6d577bc58e1c72d872a8c.svg";
export { ForwardRef as ReactComponent };